import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import CdhGOCYtvZBDcqkePnkhdwTSBVRYQamsy from "/vercel/path0/src/snippets/samples/multi-component-flex-box.mdx";
import Wrapper from "@/timvir/wrapper";
const MDXLayout = Wrapper;
import {Exhibit, Code} from "timvir/blocks";
function _createMdxContent(props) {
  const _components = {
    code: "code",
    h1: "h1",
    h2: "h2",
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "Snippets"
    }), "\n", _jsx(_components.h2, {
      children: "Multi-Component Flex Box"
    }), "\n", _jsxs(_components.p, {
      children: ["The «Multi-Component Flex Box» snippet illustrates how to use the ", _jsx(_components.code, {
        children: "<Exhibit>"
      }), " block to show\na number of small, closely related elements. The elements are centered in a flex container."]
    }), "\n", _jsx("div", {
      style: {
        marginBottom: 20
      },
      children: _jsx(CdhGOCYtvZBDcqkePnkhdwTSBVRYQamsy, {})
    }), "\n", _jsx(Code, {
      language: "markdown",
      children: "import { Exhibit } from \"timvir/blocks\";\n\n<Exhibit\n  BackdropProps={{\n    style: {\n      padding: 20,\n      display: \"flex\",\n      flexWrap: \"wrap\",\n      justifyContent: \"center\",\n      gap: 20,\n    },\n  }}\n>\n  <div style={{ background: \"#f0f8\", height: 32, width: 120 }} />\n  <div style={{ background: \"#f0f8\", height: 32, width: 80 }} />\n  <div style={{ background: \"#f0f8\", height: 32, width: 90 }} />\n  <div style={{ background: \"#f0f8\", height: 32, width: 160 }} />\n  <div style={{ background: \"#f0f8\", height: 32, width: 90 }} />\n  <div style={{ background: \"#f0f8\", height: 32, width: 100 }} />\n  <div style={{ background: \"#f0f8\", height: 32, width: 140 }} />\n  <div style={{ background: \"#f0f8\", height: 32, width: 100 }} />\n</Exhibit>\n"
    })]
  });
}
export default function MDXContent(props = {}) {
  return _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  });
}
